module.exports = __webpack_public_path__ + "static/media/sumeet_barhona3.9dd73d22.jpg";